import { render, staticRenderFns } from "./productTable.vue?vue&type=template&id=21ba29cd&scoped=true"
import script from "./productTable.vue?vue&type=script&lang=js"
export * from "./productTable.vue?vue&type=script&lang=js"
import style0 from "./productTable.vue?vue&type=style&index=0&id=21ba29cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ba29cd",
  null
  
)

export default component.exports